import {XCircle} from 'lucide-react';

import {BlueprintError} from '../../parsing/blueprintParser';

type ErrorType = Error | string | undefined;

const formatError = (error: ErrorType): {message: string; stack?: string} => {
	if (error == null || error === '') return {message: 'Unknown Error'};

	if (error instanceof Error) {
		return {
			message: error.message,
			// Blueprint errors describe bad input, so a stack trace would only add noise.
			stack: error instanceof BlueprintError ? undefined : error.stack,
		};
	}

	return {message: error};
};

export const ErrorAlert = ({error}: {error: ErrorType}) => {
	if (error == null || error === '') return null;

	const {message, stack} = formatError(error);

	return (
		<div className="panel alert alert-error mt16">
			<div className="flex items-center gap-2">
				<XCircle className="h-4 w-4" />
				<span>{message}</span>
			</div>
			{stack != null && stack !== '' ? (
				<pre className="mt-2 max-h-48 overflow-auto bg-red-950 p-4 text-sm text-red-100">{stack}</pre>
			) : null}
		</div>
	);
};
